import { useContext, useMemo, useState } from 'react';
import Papa from 'papaparse';
import { AgentCard } from '@/components/agent-chat/agent-card.component';
import {
  CardFooter,
  CardMeta,
  CardStatus,
} from '@/components/agent-chat/card-parts.component';
import { CopilotAttachContext } from '@/components/agent-chat/copilot-attach.context';
import { iconFileCsv } from '@/lib/icons';
import { pastedRowsOf } from '@/components/agent-chat/pasted-rows.util';

/**
 * Rows the user pasted into the chat (display `pasted_rows_import`). Clu keeps
 * every pasted column; the rows become a CSV and go through the chat's usual
 * import mapping card, exactly like an attached file, so the mapping, the list
 * choice and the import all stay in one place.
 */
export function PastedRowsImportCard({
  result,
}: {
  result: Record<string, unknown>;
}) {
  const attach = useContext(CopilotAttachContext);
  const [staged, setStaged] = useState(false);
  const { columns, rows } = useMemo(() => pastedRowsOf(result), [result]);

  const review = () => {
    if (!attach || rows.length === 0) return false;
    const csv = Papa.unparse({ fields: columns, data: rows });
    attach([new File([csv], 'Pasted rows.csv', { type: 'text/csv' })]);
    setStaged(true);
    return true;
  };

  const fact = (
    <CardMeta className='min-w-0'>
      {rows.length.toLocaleString()} {rows.length === 1 ? 'row' : 'rows'},{' '}
      {columns.length} {columns.length === 1 ? 'column' : 'columns'}
    </CardMeta>
  );
  return (
    <AgentCard
      icon={iconFileCsv}
      title='Pasted rows'
      trailing={staged ? <CardStatus>Mapping below</CardStatus> : undefined}
    >
      {attach && rows.length > 0 && !staged ? (
        <CardFooter
          control={fact}
          primary={{ label: 'Review import', onClick: review }}
        />
      ) : (
        fact
      )}
    </AgentCard>
  );
}
